import { Text, TextInput, Section, Grid, Column } from '@acast/decibel';
import config from 'app/config';
import T from 'prop-types';
import React from 'react';
import EmbedCodeGenerator from 'shared/components/embed-code-generator';
import Field from 'shared/components/field';

const SettingsGroupSharingAndDiscovery = ({ show }) => {
  const showUrl = show.permalinks[0];
  const rssHost = config.get('RSS_HOST', 'https://rss.acast.com');
  const playHost = config.get('PLAY_HOST', 'https://play.acast.com');
  const rssUrl = showUrl ? `${rssHost}/${showUrl}` : '';
  const acastUrl = showUrl ? `${playHost}/s/${showUrl}` : '';

  return (
    <Section>
      <Text variant="h3">Sharing &amp; Discovery</Text>
      <Grid>
        <Column width="50%">
          <Field
            name="rss-feed-url"
            label="RSS Feed URL"
            help="The address of your show's RSS feed - submit this to podcatchers and third-party platforms."
          >
            <TextInput readOnly placeholder="The RSS Feed URL is not available" value={rssUrl} />
          </Field>
        </Column>
        <Column width="50%">
          <Field
            name="acast-url"
            label="Acast URL"
            help="The web address of your show page on acast.com."
          >
            <TextInput readOnly placeholder="The Acast URL is not available" value={acastUrl} />
          </Field>
        </Column>
      </Grid>

      <Text variant="h4" mt={8}>
        Embed Player
      </Text>
      <EmbedCodeGenerator showSlug={show.permalinks[0]} />
    </Section>
  );
};

SettingsGroupSharingAndDiscovery.propTypes = {
  show: T.object,
};

export default SettingsGroupSharingAndDiscovery;
